import styled, { css } from 'styled-components';
import { Col as col } from 'antd';

const Col = styled(col)`
  ${props =>
    props.margin &&
    css`
      margin: ${props.margin};
    `}
  ${props =>
    props.flex &&
    css`
      display: flex;
      justify-content: center;
      align-items: center;
    `}
    ${props =>
    props.mt &&
    css`
      margin-top: ${props.mt}px;
    `}
    ${props =>
    props.pt &&
    css`
      padding-top: ${props.pt}px;
    `}
    ${props =>
    (props.pr || props.pr === 0) &&
    css`
      padding-right: ${props.pr}px !important;
    `}
    ${props =>
    props.content &&
    css`
      display: flex;
      justify-content: ${props.content};
    `}
    ${props =>
    props.align &&
    css`
      display: flex;
      align-items: ${props.align};
    `}
`;

/** @component */
export default Col;
